import { useMemo } from 'react';
import { Center, Flex, Spinner, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import { TFacultativeTabProps } from '../FacultativeContainer';
import RSelect from 'components/atoms/formInputs/RSelect';

const nameSplitsCols = Array(20).fill('');

const FacultativeTabTable = ({
    retailers,
    checkedList,
    readonly,
    isFacLoading,
    tag_splits,
    handleCheck,
}: TFacultativeTabProps) => {
    const translate = useTranslation();

    const options = useMemo(
        () =>
            nameSplitsCols.map((_split, idx) => ({
                label: tag_splits[idx] || `name_split_${idx + 1}`,
                value: idx + 1,
            })),
        [tag_splits],
    );

    return isFacLoading ? (
        <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
            <Spinner />
        </Center>
    ) : (
        <Flex overflow="auto">
            <Table border="1px solid" borderColor="gray.100">
                <Thead>
                    <Tr>
                        <Th>{translate('cg.retailers')}</Th>
                        <Th>{translate('splits')}</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    <Tr>
                        <Td whiteSpace="nowrap">Default</Td>
                        <Td w="100%">
                            <RSelect
                                setAll
                                options={options}
                                onChange={(facultative) => {
                                    handleCheck(
                                        'default',
                                        facultative.map((f) => Number(f)),
                                    );
                                }}
                                selectedOptions={checkedList['default']}
                                disabled={readonly}
                            />
                        </Td>
                    </Tr>
                    {retailers.map((retailer) => (
                        <Tr key={retailer.id}>
                            <Td whiteSpace="nowrap">{retailer.name}</Td>
                            <Td w="100%">
                                <RSelect
                                    setAll
                                    options={options}
                                    onChange={(facultative) => {
                                        handleCheck(
                                            retailer.id,
                                            facultative.map((f) => Number(f)),
                                        );
                                    }}
                                    selectedOptions={checkedList[retailer.id]}
                                    disabled={readonly}
                                />
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </Flex>
    );
};

export default FacultativeTabTable;
